// extracted by mini-css-extract-plugin
export default {"app-body":"App_app-body__EKq2Y"};